import React from "react";
import "./App.css";
import Video from "./Components/Video";
import data from "./DataFile/data";
function App() {
  return (
    <div className="app">
      <h2>Tik-tok clone</h2>
      <div className="app__videos">
        {data.map((video, index) => {
          return (
            <Video
              key={index}
              url={video.url}
              channel={video.channel}
              desc={video.desc}
              song={video.song}
              likes={video.likes}
              share={video.share}
              messages={video.messages}
            />
          );
        })}
      </div>
      <a href="mailto:pawan.kv612@gmail.com">Contact Developer</a>
    </div>
  );
}
export default App;
